exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-discount .invoice-discount__totals {\n  width: 100%;\n  max-width: 49rem;\n  font-size: 3rem;\n  margin: 0 auto;\n}\n\n.invoice-discount .invoice-discount__totals td {\n  text-align: right;\n}\n\n.invoice-discount .invoice-discount__totals>tbody>tr>td:last-child {\n  width: 10rem;\n}\n\n.invoice-discount .invoice-discount__totals>tbody>tr>td:first-child {\n  padding-right: 1rem;\n}\n\n", ""]);

// exports
